module.exports = __webpack_public_path__ + "static/media/SmiliesEveryday-01.9ec2acb5.jpg";